import { Typography } from "@mui/material"
import { PdfTimingTaskList } from "./pdf-timing-task-list"
import { formatMinutesLabel } from "./pdf-formatters"

export function PdfTimingSummaryRow({ item }) {
    return (
        <tr>
            <td>
                <Typography sx={{ fontWeight: 700, fontSize: "10px", color: "#374151" }}>
                    {formatFrequency(item.frequency)}
                </Typography>
                <Typography sx={{ fontSize: "10px", color: "#2b95a2", mt: "4px" }}>
                    {formatMinutesLabel(Math.round(item.minutes))}
                </Typography>
            </td>
            <td>
                <PdfTimingTaskList items={item.taskEntries} />
            </td>
        </tr>
    )
    function formatFrequency(frequency = {}) {
        const interval = frequency?.interval || 1
        const period = frequency?.period || "Unknown"
        return `${interval}${String(period).charAt(0)} (${period}s)`
    }
}
